import { EntityBase } from './entity-base';
import { LabEntity } from './lab-entity';
import { CourseVMImage } from './course-vm-image';

/**
 * Represents a training course entity with its details and associated labs.
 * @extends EntityBase
 * @class CourseEntity
 */
export class CourseEntity extends EntityBase {
  /**
   * The course code or identifier.
   * @type {string}
   * @default ""
   * @example "AZ-101", "AWS-SAA", "GCP-ACE"
   */
  public code: string = "";

  /**
   * The course provider/vendor.
   * @type {string}
   * @default ""
   * @example "Microsoft", "AWS", "Google", "Oracle"
   */
  public provider: string = "";

  /**
   * Detailed description of the course content and objectives.
   * @type {string}
   * @default ""
   */
  public description: string = "";

  /**
   * The virtual machine image configuration used for this course.
   * @type {CourseVMImage}
   * @default new CourseVMImage()
   */
  public vmImage: CourseVMImage = new CourseVMImage();

  /**
   * Array of lab entities associated with this course.
   * @type {LabEntity[]}
   * @default []
   */
  public labs: LabEntity[] = [];

  /**
   * To show or hide the menu in the course creation/editing component. 
   * This is used to toggle the visibility of the menu.
   * @type {boolean}
   * @default false
   */
  public showMenu: boolean = false;   
}
